/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { DEFAULT_PACS } from '@/constants';
// import { Pacs } from '@/types';

export type ResetOptions = {
  // conserve le type de décla pour l'étape 1 lors du reset
  keepDeclarationType?: boolean;
};

export type AssistantContextType = any & {
  onChange: any;
  onReset: (options?: ResetOptions) => void;
  onLoad: (data: any) => void;
  computedPacsNumber: string | null;
  isNumeroLocked: boolean;
  /** true si le numéro affiché a été saisi par l'utilisateur (numérotation manuelle) */
  isNumeroSaisiManuellement: boolean;
  resetPacsNumero: () => void;
  setPacsNumero: (numero: string) => void;
  errors: Record<string, any>;
  setErrors: (errors: Record<string, any>) => void;
  teledossierData?: any;
  isHubeeMode?: boolean;
  setTeledossierData: (data: any) => void;
  isLoadingHubeeData?: boolean;
  setIsLoadingHubeeData: (isLoading: boolean) => void;
  isDissolutionMode: boolean;
  setIsDissolutionMode: (isDissolutionMode: boolean) => void;
  selectedDeclarationType: string | null;
  setSelectedDeclarationType: (type: string | null) => void;
  selectedPacs: number | null;
  setSelectedPacs: (identifiant: number | null) => void;
};

const AssistantContext = React.createContext<AssistantContextType>({
  onChange: () => {},
  onReset: () => {},
  onLoad: () => {},
  computedPacsNumber: null,
  isNumeroLocked: false,
  isNumeroSaisiManuellement: false,
  resetPacsNumero: () => {},
  setPacsNumero: () => {},
  errors: {},
  setErrors: () => {},
  teledossierData: null,
  isHubeeMode: false,
  setTeledossierData: () => {},
  isLoadingHubeeData: false,
  setIsLoadingHubeeData: () => {},
  isDissolutionMode: false,
  setIsDissolutionMode: () => {},
  selectedDeclarationType: null,
  setSelectedDeclarationType: () => {},
  selectedPacs: null,
  setSelectedPacs: () => {},
  ...DEFAULT_PACS,
});

export default AssistantContext;
